/**
 * Project owners — one named person per project role.
 *
 * This is the first thing the engagement asks the client for and the thing everything
 * else queues behind: the six-week schedule assumes a decision comes back in about 48
 * hours, and that only holds if each area has one person who can decide. Gate G1
 * (mobilization complete, 4 September) does not clear until every role here has a name.
 *
 * Source: "Project Owners — Step by Step", sent to Kevin Peck.
 * https://docs.google.com/document/d/14aYTB9iCZOLA6IvTIylvW95pZGNurRHaL0-PZghfJKY/edit
 */

export type OwnerStatus = 'Confirmed' | 'Asked' | 'Unassigned'

export type Owner = {
  id: string
  order: number
  /** A backup steps in for a primary role; it is not a role of its own. */
  kind: 'primary' | 'backup'
  backupFor?: string
  /** From the plan — the client cannot rewrite these, and the rules enforce that. */
  role: string
  whatTheyDo: string
  timeEstimate: string
  gate: string
  mustBeOneIndividual: boolean
  notable: string
  /** The client's answers. */
  name: string
  email: string
  status: OwnerStatus
  notes: string
  confirmedBy?: string | null
  confirmedAt?: { seconds: number } | null
}

export const STATUS_OPTIONS: OwnerStatus[] = ['Unassigned', 'Asked', 'Confirmed']

export const statusTone = (s: OwnerStatus) =>
  s === 'Confirmed' ? 'done' : s === 'Asked' ? 'high' : 'critical'

/** A row is only settled when somebody is named *and* they have said yes. */
export const isSettled = (o: Owner) => o.status === 'Confirmed' && o.name.trim() !== ''

export const isNamed = (o: Owner) => o.name.trim() !== ''

/** Gate G1 — mobilization complete. It does not clear while a role has no owner. */
export const OWNERS_DUE = '2026-09-04'

export const DOC_URL =
  'https://docs.google.com/document/d/14aYTB9iCZOLA6IvTIylvW95pZGNurRHaL0-PZghfJKY/edit'
